import BaseModelAPI from '../BaseModelAPI';

export default class InboxList extends BaseModelAPI {

	static entity = 'inboxlist'
	static entityName = 'inbox';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
